/* Aino chat cart attribution: match the exact recommended variant. */
(() => {
  'use strict';
// Only size inputs belong on the purchased line. Never include conversation text,
// contact details, inferred measurements, analytics data or another product's profile.
const fields=[
 ['heightCm','Pituus',100,250,'cm'],['weightKg','Paino',25,350,'kg'],
 ['bodyChestCm','Rinnanympärys',60,220,'cm'],['bodyWaistCm','Vyötärönympärys',50,220,'cm'],['bodyHipCm','Lantionympärys',60,230,'cm'],
 ['garmentChestCm','Kainaloleveys',30,120,'cm'],['garmentWaistCm','Vyötärön tasoleveys',20,100,'cm'],['garmentHipCm','Lantion tasoleveys',25,130,'cm'],
 ['garmentInseamCm','Sisälahje',15,125,'cm'],['garmentOutseamCm','Ulkosauma',15,150,'cm'],['garmentHemCm','Helman leveys',25,150,'cm'],
 ['garmentBackLengthCm','Selkäpituus',30,150,'cm'],['garmentLengthCm','Vaatteen pituus',25,150,'cm'],['garmentFrontLengthCm','Etupituus',25,150,'cm'],['garmentSleeveCm','Hiha',8,110,'cm']
];
const size=v=>typeof v==='string'&&/^(?:[2-9]?X{0,3}[SML]|\d{1,3}|W?\d{2}(?:\/L?\d{2})?)$/i.test(v.trim())?v.trim().toUpperCase():null;
function ainoSizeDetails(profile={}){
 const valid=fields.filter(([key,,min,max])=>Number.isFinite(profile?.[key])&&profile[key]>=min&&profile[key]<=max);
 const usual=size(profile?.usualSize);
 if(!valid.length&&!usual)return {};
 const method=valid.some(([k])=>k.startsWith('garment'))?'Vaatteen mitat':valid.some(([k])=>k.startsWith('body'))?'Vartalon ympärysmitat':valid.some(([k])=>k==='heightCm')&&valid.some(([k])=>k==='weightKg')?'Pituus ja paino':valid.some(([k])=>k==='heightCm')?'Pituus':valid.some(([k])=>k==='weightKg')?'Paino':'Tuttu vaatekoko';
 const inputs=valid.map(([k,label,,,unit])=>label+': '+Number(profile[k].toFixed(1))+' '+unit);
 if(usual)inputs.push('Tuttu koko: '+usual);
 return {_aino_size_method:method,_aino_size_inputs:inputs.join('; ')};
}

// Cart boundary: accept only the canonical, finite size-field representation.
function cleanAinoSizeDetails(properties){
 if(typeof properties?._aino_size_inputs!=='string'||properties._aino_size_inputs.length>1024)return {};
 const profile={};
 for(const part of properties._aino_size_inputs.split('; ')){
  if(part.startsWith('Tuttu koko: ')){profile.usualSize=part.slice(12);continue;}
  const field=fields.find(([,label])=>part.startsWith(label+': '));if(!field)return {};
  const [key,label,,,unit]=field,raw=part.slice(label.length+2,-unit.length-1);
  if(!/^\d+(?:\.\d)?$/.test(raw))return {};profile[key]=Number(raw);
 }
 const clean=ainoSizeDetails(profile);
 return clean._aino_size_method===properties._aino_size_method&&clean._aino_size_inputs===properties._aino_size_inputs?clean:{};
}

  const key='disturb:aino:chat-variant:v1';
  document.addEventListener('disturb:aino-size-invalidated',event=>{if(event.detail?.path===location.pathname)try{sessionStorage.removeItem(key);}catch{}});
  const number=v=>String(v||'').match(/([0-9]+)$/)?.[1]||'';
  document.addEventListener('disturb:aino-size-recommended',event=>{
    const variantId=number(event.detail?.variantId);
    if(!variantId||event.detail?.path!==location.pathname)return;
    try{sessionStorage.setItem(key,JSON.stringify({variantId,path:location.pathname,at:Date.now(),sizeDetails:cleanAinoSizeDetails(event.detail?.sizeDetails)}));}catch{}
  });
  const original=window.fetch.bind(window);
  window.fetch=function(input,init){
    try{
      const url=new URL(typeof input==='string'?input:input.url,location.href);
      if(url.origin===location.origin && /\/cart\/add\.js$/.test(url.pathname) && typeof init?.body==='string'){
        const body=JSON.parse(init.body);
        const record=JSON.parse(sessionStorage.getItem(key)||'null');
        if(record && record.path===location.pathname && Date.now()-record.at<7200000 && Array.isArray(body.items)){
          for(const item of body.items){
            if(number(item.id)===record.variantId){
              item.properties={...item.properties,_aino_size_recommendation:'Kokosuositusta käytetty',...cleanAinoSizeDetails(record.sizeDetails)};
            }
          }
          init={...init,body:JSON.stringify(body)};
        }
      }
    }catch{}
    return original(input,init);
  };
})();
